import { DataGrid } from "components/DataGrid/DataGrid";
import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Toast } from "components/ToastShow/ToastAlert";
import { getEnv } from "config/runtimeEnv";
import { useEffect, useState } from "react";

import { ContactType, MessageType } from "types/enum";
import { callConnection } from "utils/callHub";
import { GUID_EMPTY } from "utils/constants";
import { getGridSetting, getPageSize, trans } from "utils/helpers";
import {
    deletePersonContact,
    getCustomerPhoneNumbers,
    setDefault
} from "./api";
import { PhoneForm } from "./PhoneForm";
import { Toolbar } from "components/Toolbar/Toolbar";


interface ContactForm {
  customerPositionId?: any;
  mode?:any
}

export const ContactForm = ({ customerPositionId,mode }: ContactForm) => {

  const [loadingPhoneNumbers, setLoadingPhoneNumbers] = useState(false);
  const [messagePhoneNumbersType, setMessagePhoneNumbersType] = useState<any>("info");

  const [showPhoneForm,setShowPhoneForm]=useState<any>(false)
  const [forceUpdate,setForceUpdate]=useState(false)
  const [selectedObj,setSelectedObj]=useState<any>()

  const [responsePhoneNumbers, setResponsePhoneNumbers] = useState<any>();
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(25);
  const [search, setsearch] = useState(null);
  const [pages, setPages] = useState<number>(0);
  const [filterAndSort, setFilterAndSort] = useState<any>(null);

 let customFuction: any = [
      [
   (callConnection?._connectionState=="Connected" && (selectedObj?.ContactTypeEnum==ContactType.Mobile || selectedObj?.ContactTypeEnum==ContactType.Phone) )?  async (e) => {
       const res = await callConnection.invoke("OriginateCall" ,e?.Value);
      }:null,
      "phone",
      "call",
    ],
    [
      (e) => {
        setDefaultAsync(e.Id);
      },
      "map-pin",
      "setasdefault",
    ],

  ];




    const setDefaultAsync = async (Id) => {
      try {
  
          try {
            const response = await setDefault(Id);
           setForceUpdate(!forceUpdate)
          
          } catch (error) {
          
          }
        
      } catch (error) {}
    };
      const handleChangePageSize = (e: any) => {
          setPageNum(1);
          setPageSize(e.currentTarget.value);
          getPageSize("ContactsInfoList", e.currentTarget.value)
          getCustomerPhoneNumbersAsync(1);
      };
      const handleGoPage = (value) => {
          if (value) {
              setPageNum(+value);
              getCustomerPhoneNumbersAsync(+value);
          } else {
          }
      };
      const handleNextPage = () => {
          if (responsePhoneNumbers.TotalRecords && ((responsePhoneNumbers.TotalRecords / pageSize) > pageNum)) {
              setPageNum((pageNum) => { return +pageNum + 1 });
              getCustomerPhoneNumbersAsync(pageNum + 1);
  
          }
      };
      const handlePrevPage = () => {
          if (pageNum > 1) {
              setPageNum((pageNum) => { return +pageNum - 1 });
              getCustomerPhoneNumbersAsync(pageNum - 1);
          }
      };
  
    const clickToolbarCallback = (clickedButtonName: string) => {
      switch (clickedButtonName.toLowerCase()) {
      
     
        case "create":
         setShowPhoneForm(true)
          break;
       case "refresh":
         setForceUpdate(!forceUpdate)
          break;
  
  
    
      }
    };



  async function getCustomerPhoneNumbersAsync(pagNum = pageNum, searchSTR = search) {
    setLoadingPhoneNumbers(false);

    try {
      let pageSizeChangedByUser = getPageSize("ContactsInfoList")
      setPageSize(pageSizeChangedByUser)
      const res = await getCustomerPhoneNumbers(customerPositionId,pagNum, pageSizeChangedByUser, searchSTR, filterAndSort?.OrderFormat?.join(","), filterAndSort?.Filterlist);
      setResponsePhoneNumbers(res.Data);
      if (res.Data.Data.length > 0) {
        setPages(
          res.Data.TotalRecords > pageSizeChangedByUser
            ? Math.ceil(res.Data.TotalRecords / pageSizeChangedByUser)
            : 1
        );
      }
    } catch (error) {
      setMessagePhoneNumbersType("error");
    }
    setLoadingPhoneNumbers(true);
  }

const deletePersonContactAsync=async(id)=>{

  try{
    await deletePersonContact(id)
    setForceUpdate(!forceUpdate)
  }catch(error){

  }
}



  useEffect(() => {
    if(filterAndSort!=null){

      getCustomerPhoneNumbersAsync();
    }
  }, [forceUpdate,filterAndSort]);

  useEffect(() => {
    let settings = getGridSetting("ContactsInfoList");
    setFilterAndSort({ Filterlist: settings[0], OrderFormat: settings[1] });
  }, []);
  return (
    <>
    {
      showPhoneForm && 

            <ModalForm
                checkClose={false}
                onHide={() => setShowPhoneForm(false)}
                show={showPhoneForm}
                title="PersonContact"
              >
             <PhoneForm onHide={()=>setShowPhoneForm(false)} customerPositionId={customerPositionId} reset={()=>setForceUpdate(!forceUpdate)}/>
              </ModalForm>
    }
       <Toolbar
     
        create={mode!='view' ?true:false}
      excel={false}
      view={false}
      helpBtn={false}
      
        handleClickToolbar={clickToolbarCallback}
      
      />
        <div className="card card-body p-3">
        
         

       
                {loadingPhoneNumbers?     
                <>
              
                {responsePhoneNumbers?.Data && responsePhoneNumbers?.Data.length > 0 ? (
               
               



                    <>
                      <DataGrid
                        ViewParametr={"NotSeen"}
                        handlefiltering={(str: any) => {
                          str.Filterlist != undefined
                            ? setFilterAndSort(str)
                            : setFilterAndSort({
                                ...filterAndSort,
                                Filterlist: str,
                              });
                        }}
                        filterStr={filterAndSort.Filterlist}
                        orderFormatList={filterAndSort.OrderFormat}
                        orderFormat={(order) => {
                          setFilterAndSort({
                            ...filterAndSort,
                            OrderFormat: order,
                          });
                        }}
                        customFuction={customFuction}
                        selectedRowObjectCallback={(e)=>setSelectedObj(e)}
                        handleDelete={(e)=>{Toast(trans("msg_deleteconfirm"), MessageType.confirmDelete ,()=> deletePersonContactAsync(selectedObj.Id))}}
                        rowSelected={selectedObj}
                        // firstColumnOprationCustom={{show:true,function:()=>{
                        //   setShowPhoneForm(true)
                        // },iconName:'plus'}}
                        parentName={"ContactsInfoList"}
                        totalRecords={responsePhoneNumbers.Data.find((item)=>item.Id==GUID_EMPTY)?0:responsePhoneNumbers.TotalRecords >0?responsePhoneNumbers.TotalRecords:0}
                        theadData={Object.keys(responsePhoneNumbers.Data[0])}
                        tbodyData={responsePhoneNumbers.Data.map((item)=>item.Id==GUID_EMPTY?{...item,Id:null}:item)}
                        minCellWidth={80}
                        startIndex={2}
                        pageNum={pageNum}
                        pageSize={pageSize}
                        HandleNextPage={handleNextPage}
                        HandlePrevPage={handlePrevPage}
                        handlechangePageSize={handleChangePageSize}
                        first={() => { getCustomerPhoneNumbersAsync(pages); setPageNum(pages) }}
                        end={() => { getCustomerPhoneNumbersAsync(1); setPageNum(1) }}
                        handleGoPage={handleGoPage}
                      />
                    
                    </>
            
                ) : (
                  <Message message={"NoDataForPreview"} type={messagePhoneNumbersType} />
                )}
                </>
                :<Loading/>}
              </div>

       
       
          
   

    </>
  );
};
